import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { ReactComponent as BurgerMenuIcon } from "../../assets/menu.svg";
import anime from "animejs";
import { ReactComponent as _CloseIcon } from "../../assets/double-left-chevron.svg";

const MenuWrapper = styled.div`
  display: flex;
  position: absolute;
  /* z-index: -100; */
  font-size: 16px;
  height: 100vh;
  /* overflow: hidden; */
  width: 0;
`;

const MenuContentWrapper = styled.div`
  display: flex;
  position: absolute;
  z-index: 1000;
  font-size: 16px;
  height: 100%;

  /* overflow: hidden; */
  width: 100vw;
`;

const MenuContent = styled.div`
  position: absolute;
  background: white;
  /* top: 50px; */
  /* border: 1px solid #800; */
  opacity: 0;
  box-shadow: 1px 1px 8px 0px #333;
  height: 500px;
  width: 280px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 20px;
  ${({ height }) =>
    height > 0 &&
    css`
      height: ${height}px;
    `};

  .header {
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.2);
    padding: 6px;
  }

  .content {
    overflow: auto;
    display: flex;
    flex-direction: column;

    a {
      text-decoration: none;
      color: black;
      font-weight: bold;
      flex: 1 1 auto;
      padding: 6px;

      &:hover {
        background: rgba(0, 0, 0, 0.2);
      }
    }
  }
`;

const BurgerMenu = styled(BurgerMenuIcon)`
  /* position: absolute; */
  z-index: 1000;
  width: 20px;
  height: 20px;
  margin-top: 10px;
  margin-left: 10px;
  fill: #fff;
  transition: all 200ms;

  div &:hover {
    transform: scale(1.3);
  }
`;

const CloseMenuBtn = styled.div`
  position: absolute;
  right: 18px;

  &:hover svg {
    transform: scale(1.3);
    /* background: blue; */
  }
`;
const CloseMenu = styled(_CloseIcon)`
  width: 20px;
  height: 20px;

  fill: #777;
  transition: all 200ms;

  div &:hover {
    transform: scale(1.3);
  }
`;

const Button = styled.div`
  width: 20px;
  height: 20px;
  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `}

  &:hover svg {
    transform: scale(1.3);
    /* background: blue; */
  }
`;

// ******************************************************
// Menu item
// ******************************************************

const MenuItem = styled(Link)`
display:block;
  color: #333;
  margin-top: 4px;
  padding: 8px;
  border-radius: 4px;
  font-size: 17px;
  font-weight: bold;
  text-decoration:  none;



  &:hover {
    background: #eee;

  }
`;

// ******************************************************

const Header = styled.div`
  flex: 0 0 auto;
  margin-top: 15px;
`;

const Top = styled.div`
  display: flex;
  flex-direction: row;
`;

const ProfileImage = styled.div`
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border-radius: 50px;
  overflow: hidden;

  img {
    width: 110%;
  }
`;

const ProfileContent = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  font-size: 10px;
  color: #aaa;
  justify-content: center;

  div:first-child {
    font-weight: bold;
    font-size: 14px;
    color: #333;
  }
`;

const Content = styled.div`
  margin-top: 15px;
  flex: 1 1 auto;
  overflow: auto;
`;

// **********************************************************************************
//
// MENU Component
//
// **********************************************************************************
const Menu = props => {
  const [state, setState] = useState({
    menu: [
      {
        title: "Aktiviteter",
        link: "/activities/-100/any",
        access: ["admin", "writer"]
      },
      {
        title: "Alle Medlemmer",
        link: "/members/-1/any",
        access: ["admin", "writer", "member"]
      },
      {
        title: "Nye medlemmer",
        link: "/members/-1/ny",
        access: ["admin", "writer"]
      },
      { title: "Graduering", link: "/ranking/-1", access: ["admin"] },
      { title: "Statistik", link: "/stat", access: ["admin", "writer"] },
      { title: "Indmeldelse", link: "/newmember", access: ["public"] },
      {
        title: "Shinka Ichiban",
        link: "/membersTestSheet/2/any",
        access: ["admin", "writer"]
      },
      {
        title: "Shinka Ung/voksen",
        link: "/membersTestSheet/1/any",
        access: ["admin", "writer"]
      },
      {
        title: "Shinka Børneholdet",
        link: "/membersTestSheet/0/any",
        access: ["admin", "writer"]
      },
      {
        title: "Medlemsoversigt nye",
        link: "/membersdetailtable/-1/ny",
        access: ["admin", "writer"]
      },
      {
        title: "Medlemsoversigt Børneholdet",
        link: "/membersdetailtable/0/any",
        access: ["admin", "writer"]
      },
      {
        title: "Medlemsoversigt Voksne",
        link: "/membersdetailtable/1/any",
        access: ["admin", "writer"]
      },
      {
        title: "Medlemsoversigt Ichiban",
        link: "/membersdetailtable/2/any",
        access: ["admin", "writer"]
      },
      {
        title: "Medlemsoversigt Passive",
        link: "/membersdetailtable/3/any",
        access: ["admin", "writer"]
      },
      {
        title: "Resultater Børneholdetet",
        link: "/membersTestResultSheet/0/any",
        access: ["admin", "writer"]
      },
      {
        title: "Resultater Voksne",
        link: "/membersTestResultSheet/1/any",
        access: ["admin", "writer"]
      },
      {
        title: "Resultater Ichiban",
        link: "/membersTestResultSheet/2/any",
        access: ["admin", "writer"]
      },
      {
        title: "CSV Børnehold",
        link: "/memberscsv/0/any",
        access: ["admin", "writer"]
      },
      {
        title: "CSV Voksne",
        link: "/memberscsv/1/any",
        access: ["admin", "writer"]
      },
      {
        title: "CSV Ichiban",
        link: "/memberscsv/2/any",
        access: ["admin", "writer"]
      },
      {
        title: "Log af",
        link: "/logout",
        access: ["admin", "writer", "member"]
      },
    ]
  });
  const menuWrapperRef = useRef(null);
  const menuContentWrapperRef = useRef(null);
  const menuContentRef = useRef(null);
  const [open, setOpen] = useState(false);

  const hasPublicAccess = access => {
    return access.find(a => a == "public");
  };

  const userHasAccess = access => {
    return (
      props.currentlyLoggedInUser &&
      access.find(a => {
        return (
          props.currentlyLoggedInUser.uidProfile.accessType &&
          props.currentlyLoggedInUser.uidProfile.accessType[a] == true
        );
      })
    );
  };

  useEffect(() => {
    setOpen(props.open);
  }, []);

  useEffect(() => {
    if (open) {
      anime.set(menuContentWrapperRef.current, {
        zIndex: 500
      });

      anime({
        targets: menuContentWrapperRef.current,
        background: "rgba(0,0,0,0.3)",
        easing: "linear",
        duration: 200
        // opacity: 1
      });

      anime({
        targets: menuContentRef.current,
        translateX: 0,
        easing: "easeOutCubic",
        duration: 400,
        opacity: 1
      });
    } else {
      anime({
        targets: menuContentWrapperRef.current,
        easing: "linear",
        background: "rgba(0,0,0,0)",
        duration: 200,
        zIndex: -500
      });

      anime({
        targets: menuContentRef.current,
        translateX: (menuContentRef.current.clientWidth + 10) * -1,
        easing: "easeOutCubic",
        opacity: 0,
        duration: 400
      });
    }
  }, [open]);

  const openMenu = () => {
    setOpen(true);
  };

  const toggleOpen = () => {
    setOpen(!open);
  };

  const closeMenu = () => {
    setOpen(false);
  };

  // m.access.find(a => a == props.currentlyLoggedInUser)

  const menuitems = state.menu.map(m => {
    // console.log("currentlyloggedinuser = ", props.currentlyLoggedInUser);
    return hasPublicAccess(m.access) || userHasAccess(m.access) ? (
      <MenuItem key={m.link} to={m.link} onClick={() => closeMenu()}>
        {m.title}
      </MenuItem>
    ) : null;
  });

  const menu = (
    <>
      {menuitems}
      {props.currentlyLoggedInUser &&
      props.currentlyLoggedInUser.displayName ? null : (
        <MenuItem to="/login" onClick={() => closeMenu()}>
          Log ind
        </MenuItem>
      )}
    </>
  );

  const currentUidProfile =
    props.currentlyLoggedInUser && props.currentlyLoggedInUser.uidProfile;

  return (
    <MenuWrapper ref={menuWrapperRef}>
      <Button onClick={() => toggleOpen()} color={props.color}>
        <BurgerMenu />
      </Button>

      <MenuContentWrapper
        ref={menuContentWrapperRef}
        onClick={() => closeMenu()}
      >
        <MenuContent
          ref={menuContentRef}
          // height={menuWrapperRef.current && menuWrapperRef.current.clientHeight}
          height={menuWrapperRef.current && (menuWrapperRef.current.clientHeight - 40)}
        >
          <CloseMenuBtn onClick={() => closeMenu()} color={props.color}>
            <CloseMenu />
          </CloseMenuBtn>

          <Header>
            <Top>
              <ProfileImage>
                <img src={currentUidProfile && currentUidProfile.photoUrl} />
              </ProfileImage>
              <ProfileContent>
                <div>{currentUidProfile && currentUidProfile.Name}</div>
                <div>{currentUidProfile && currentUidProfile.Uid}</div>
              </ProfileContent>
            </Top>
          </Header>
          <Content>{menu}</Content>
        </MenuContent>
      </MenuContentWrapper>
    </MenuWrapper>
  );
};

export default Menu;
